import React, { useEffect, useState } from "react";
import { PageHero, FadeUp } from "../../components/public/Section";
import { api, mediaUrl } from "../../lib/api";

export default function PastPresidents() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/committee?past=true").then((r) => setItems(r.data || [])); }, []);
  return (
    <div>
      <PageHero title="Past Presidents" subtitle="Honoring the leaders who shaped the Society." breadcrumbs={["Home", "Members", "Past Presidents"]} />
      <section className="section container-page">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((c) => (
            <FadeUp key={c.id} className="card-elev p-6 text-center">
              <img src={mediaUrl(c.photo)} alt={c.name} className="w-28 h-28 rounded-full object-cover mx-auto ring-4 ring-brand-primary-light" />
              <div className="font-serif font-bold text-brand-text text-lg mt-4">{c.name}</div>
              <div className="text-xs text-brand-primary font-semibold uppercase tracking-wider mt-1">{c.designation}</div>
            </FadeUp>
          ))}
          {items.length === 0 && <div className="col-span-full text-center text-brand-muted py-16">No past presidents recorded.</div>}
        </div>
      </section>
    </div>
  );
}
